import { render, staticRenderFns } from "./TableOfContents.vue?vue&type=template&id=2a5e52ec&scoped=true"
import script from "./TableOfContents.vue?vue&type=script&lang=js"
export * from "./TableOfContents.vue?vue&type=script&lang=js"
import style0 from "./TableOfContents.vue?vue&type=style&index=0&id=2a5e52ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5e52ec",
  null
  
)

export default component.exports